import { render, staticRenderFns } from "./ModalRemoverCronometroTarja.vue?vue&type=template&id=dbc4d25e"
import script from "./ModalRemoverCronometroTarja.vue?vue&type=script&lang=js"
export * from "./ModalRemoverCronometroTarja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports